import { flagIcons, socialIcons } from "../../assets/icons";
import {BITCOINCASH_TWITTER, BITCOINCASH_URL, NUMERO_REPORTE} from "../../constants"
export default function Footer() {
  return (
    <section className="w-full max-w-[700px] flex flex-row items-center justify-center text-sub_text_color mt-10 pt-10 border-t border-gray-700 gap-10 flex-wrap">
      <a className="hover:text-main_accent cursor-pointer flex flex-row gap-3 items-center" href="https://bitcoincashargentina.com/">
        Made in BCH Argentina {flagIcons.es}
      </a>
      <div className="flex flex-row gap-4">
        <a className="hover:text-main_accent " href={`https://api.whatsapp.com/send?phone=${NUMERO_REPORTE}`}>{socialIcons.whatsapp}</a>
        <a className="hover:text-main_accent " href={BITCOINCASH_URL}>{socialIcons.instagram}</a>
        <a className="hover:text-main_accent " href={BITCOINCASH_TWITTER}>{socialIcons.twitter}</a>
      </div>
    </section>
  );
}
